import './PreventiveDetails.scss';

import PreventiveDetailsHeader from "./components/PreventiveDetailsHeader/PreventiveDetailsHeader";
import PreventiveDetailsContent from "./components/PreventiveDetailsContent/PreventiveDetailsContent";

const PreventiveDetails = () => {

    return (
        <div className={"preventive-details"}>
            <div className={"preventive-details_container"}>
                 <div className={"preventive-details_header"}>
                     <PreventiveDetailsHeader/>
                 </div>
                <div className={"preventive-details_content"}>
                    <PreventiveDetailsContent/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveDetails;